import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

import "legacy/controllers/swiper";
import "assets/stylesheets/themes/phoenix.scss";
import "legacy/plugins/rails";
import "legacy/plugins/images";
import "legacy/plugins/iterable";
import "jquery-validation/dist/jquery.validate";
import "jquery-validation/dist/additional-methods";
import "legacy/plugins/fontawesome/phoenix";
import "legacy/plugins/jquery";
import "legacy/plugins/bootstrap/popovers";
import "legacy/plugins/bootstrap/tooltips";
import "legacy/plugins/bootstrap/modals";
import "legacy/controllers";
import "legacy/jquery/navigation";
import "legacy/jquery/forms/errorMessages";
import "legacy/jquery/forms/customValidators";
import "legacy/jquery/forms/emailAutocorrect";
import "legacy/jquery/forms/signUp";
import "legacy/jquery/forms/smsVerification";
import "legacy/jquery/forms/editPassword";
import "legacy/jquery/forms/passwordVisibilityToggle";
import "legacy/jquery/pages/phoenix";
import "legacy/jquery/pages/rankings";
import "../../assets/stylesheets/promoting-app-banner.scss";
import "legacy/controllers/service_requests/show";
import "legacy/controllers/charCounters";
import "legacy/controllers/sp-profile";
import "legacy/controllers/reviews/new";
import "legacy/controllers/private_comment/client";

import { init as initShareButtons } from "legacy/jquery/components/shareButtons";
import { init as initBottomBanner } from "legacy/jquery/components/bottomBanner";
import { init as initbottomBannerThreshold } from "legacy/jquery/components/bottomBannerThreshold";


import initReactApp from "@config/init";

document.addEventListener("DOMContentLoaded", () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).theme = "phoenix";
  initReactApp();
  initShareButtons();
  initBottomBanner();
  initbottomBannerThreshold();
});
